import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class VideoV3 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'
        let imagealt = 'image'

    return  <section className="video-three" style={{backgroundImage: 'url('+publicUrl+'assets/images/resources/service-video-banner.jpg)'}}>
            <div className="container text-center">
              <a href="#" className="video-popup video-three__btn"><i className="fa fa-play" /></a>
            </div>{/* /.container */}
          </section>

        }
}

export default VideoV3